import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  ApiResponse, OnboardingResponse, OnboardingRegisterRequest,
  OnboardingUserRequest, UserProfileResponse, MemberClass
} from '../models/models';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OnboardingService {
  private readonly apiUrl = `${environment.apiUrl}/onboarding`;

  public readonly memberClasses: MemberClass[] = [
    { code: 'GOV', name: 'Government Ministries, Departments & Agencies (MDAs)', description: 'Public Sector Ministerial and Executive Authorities' },
    { code: 'COM', name: 'Commercial & Private Sector Entities', description: 'Financial Institutions, Telecoms & Private Corporations' },
    { code: 'NGO', name: 'Non-Governmental Organizations & Civil Society', description: 'Registered Non-Profit Foundations & Civil Missions' },
    { code: 'MUNI', name: 'Municipalities & Local Government Authorities', description: 'Urban Councils & District Local Administrations' }
  ];

  constructor(private http: HttpClient) {}

  getMemberClasses(): Observable<ApiResponse<MemberClass[]>> {
    return this.http.get<ApiResponse<MemberClass[]>>(`${environment.apiUrl}/member-classes`);
  }

  registerInstitution(request: OnboardingRegisterRequest): Observable<ApiResponse<OnboardingResponse>> {
    return this.http.post<ApiResponse<OnboardingResponse>>(`${this.apiUrl}/register`, request);
  }

  createInitialUser(request: OnboardingUserRequest): Observable<ApiResponse<UserProfileResponse>> {
    return this.http.post<ApiResponse<UserProfileResponse>>(`${this.apiUrl}/user`, request);
  }

  getOnboardingByUid(uid: string): Observable<ApiResponse<OnboardingResponse>> {
    return this.http.get<ApiResponse<OnboardingResponse>>(`${this.apiUrl}/${uid}`);
  }

  getAllOnboardings(): Observable<ApiResponse<OnboardingResponse[]>> {
    return this.http.get<ApiResponse<OnboardingResponse[]>>(this.apiUrl);
  }

  approveOnboarding(uid: string): Observable<ApiResponse<OnboardingResponse>> {
    return this.http.post<ApiResponse<OnboardingResponse>>(`${this.apiUrl}/approve/${uid}`, {});
  }

  rejectOnboarding(uid: string, request: { reason: string }): Observable<ApiResponse<OnboardingResponse>> {
    return this.http.post<ApiResponse<OnboardingResponse>>(`${this.apiUrl}/reject/${uid}`, request);
  }

  returnForCorrection(uid: string, request: { reason: string }): Observable<ApiResponse<OnboardingResponse>> {
    return this.http.post<ApiResponse<OnboardingResponse>>(`${this.apiUrl}/return/${uid}`, request);
  }

  getOnboardingByToken(token: string): Observable<ApiResponse<OnboardingResponse>> {
    return this.http.get<ApiResponse<OnboardingResponse>>(`${this.apiUrl}/token/${token}`);
  }

  lookupStatus(token: string): Observable<ApiResponse<OnboardingResponse>> {
    return this.http.get<ApiResponse<OnboardingResponse>>(`${this.apiUrl}/lookup`, {
      params: { token: token.trim() }
    });
  }

  resubmitOnboarding(token: string, request: OnboardingRegisterRequest): Observable<ApiResponse<OnboardingResponse>> {
    return this.http.put<ApiResponse<OnboardingResponse>>(`${this.apiUrl}/resubmit/${token}`, request);
  }
}
